import { render, staticRenderFns } from "./QuestionnaireDetailModal.vue?vue&type=template&id=667c8b06&scoped=true&"
import script from "./QuestionnaireDetailModal.vue?vue&type=script&lang=js&"
export * from "./QuestionnaireDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./QuestionnaireDetailModal.vue?vue&type=style&index=0&id=667c8b06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667c8b06",
  null
  
)

export default component.exports